var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardBookSpaceHoticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 54,
    viewBox: "0 0 59 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_8377_9534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.58008 48.4452H23.8143C23.8143 46.2924 22.9591 44.2278 21.4368 42.7056C19.9146 41.1833 17.85 40.3281 15.6972 40.3281C13.5444 40.3281 11.4798 41.1833 9.95752 42.7056C8.43527 44.2278 7.58008 46.2924 7.58008 48.4452Z",
    stroke: "black",
    strokeWidth: 2.36134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2563 39.0875L7.44554 34.0447C4.35961 32.0523 3.7722 27.7798 6.20597 25.0285L13.0801 17.2578",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0274 14.331C11.7569 13.5645 11.9772 12.7105 12.5847 12.1705L15.3843 9.682C16.0222 9.11496 16.9496 9.01523 17.6935 9.43366L22.5939 12.1901C23.8108 12.8746 23.9696 14.5638 22.9017 15.4631L17.0388 20.4003C15.9695 21.3008 14.3298 20.8544 13.8645 19.5361L12.0274 14.331Z",
    fill: "#C1F700",
    stroke: "black",
    strokeWidth: 2.36134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0892 27.8438H45.7928C44.903 27.8438 44.1816 28.5651 44.1816 29.4549V36.3024C44.1816 37.1922 44.903 37.9135 45.7928 37.9135H50.0892C50.9791 37.9135 51.7004 37.1922 51.7004 36.3024V29.4549C51.7004 28.5651 50.9791 27.8438 50.0892 27.8438Z",
    fill: "#1C1C1E",
    stroke: "white",
    strokeWidth: 1.18067,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6992 30.5312C52.1977 30.5312 52.6759 30.7293 53.0284 31.0818C53.3809 31.4343 53.5789 31.9124 53.5789 32.4109C53.5789 32.9095 53.3809 33.3876 53.0284 33.7401C52.6759 34.0926 52.1977 34.2906 51.6992 34.2906",
    stroke: "black",
    strokeWidth: 1.18067,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.553 20.0703H23.4747C21.8696 20.0703 20.5684 21.3715 20.5684 22.9766V30.2424C20.5684 31.8475 21.8696 33.1487 23.4747 33.1487H36.553C38.1582 33.1487 39.4594 31.8475 39.4594 30.2424V22.9766C39.4594 21.3715 38.1582 20.0703 36.553 20.0703Z",
    fill: "#C1F700",
    stroke: "black",
    strokeWidth: 2.17973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0137 34.9375L30.0137 38.4795",
    stroke: "black",
    strokeWidth: 3.1253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0273 38.8203H52.4474",
    stroke: "#1C1C1E",
    strokeWidth: 2.36134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2344 40L47.2344 47.9142",
    stroke: "black",
    strokeWidth: 3.1253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_8377_9534",
    x: 0,
    y: 0,
    width: 58.1699,
    height: 53.925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8377_9534"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8377_9534",
    result: "effect2_dropShadow_8377_9534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8377_9534",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBookSpaceHoticon);
export default __webpack_public_path__ + "static/media/dashboard-book-space-hoticon.45033eb3ca5143f953be3439c61849be.svg";
export { ForwardRef as ReactComponent };